export default __webpack_public_path__ + "static/media/Mobile_notification_SVG.03a47a07.svg";